// components/ConfirmDeleteModal.js
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Button from "../Button/Button";
import Typography from "../Typography";

function ConfirmDeleteModal({ onClose, onConfirm, isLoading = false }) {
	const { t } = useTranslation("userProfile");

	return (
		<Overlay>
			<Modal>
				<Typography as="h2" $variant="title-5-semibold">
					{t("settings.account.deleteModal.title")}
				</Typography>
				<Typography as="p" $variant="body-2-medium">
					{t("settings.account.deleteModal.description")}
				</Typography>
				<ButtonContainer>
					<Button onClick={onClose} $variant="outline" disabled={isLoading}>
						{t("settings.account.deleteModal.cancel")}
					</Button>
					<Button
						onClick={onConfirm}
						$variant="defaultDanger"
						disabled={isLoading}
					>
						{isLoading
							? t("settings.account.deleteModal.loading")
							: t("settings.account.deleteModal.confirm")}
					</Button>
				</ButtonContainer>
			</Modal>
		</Overlay>
	);
}

export default ConfirmDeleteModal;

const Overlay = styled.div`
  background: rgb(0 0 0 / 50%); height:100%; left:0;

  /* estilos de overlay */
  position: fixed;
  top:0;
  width:100%;
`;

const Modal = styled.div`
  /* estilos de modal */
  background: #fff;
  border-radius: 8px;
  margin: auto;
  margin-top: 100px;
  padding: 24px;
  width: 400px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 16px;
`;
